export default {"src":"/_next/static/media/featured-sparkle.74bc9bb8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};